<dv-dialog-content>
  @if(value()){
  <dv-radio-group
    [items]="items()"
    [value]="value()"
    (valueChange)="onValueChange($event)"
    valueKey="value"
    labelKey="label"
  ></dv-radio-group>
  }
  <dv-button footer-right color="default" (click)="onConfirm()">
    {{ 'Button.Close' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="save()"
    [disabled]="translate.getCurrentLang() === value()"
  >
    {{ 'Button.Save' | translate }}
  </dv-button>
</dv-dialog-content>
